import { ze } from "utils/zhEn";
/** AI 抽屉显示的内容类型，由 zustand start* action 设置，AiDrawer 读取 */
export const AiContentType = {
    IssueAnalysis: 'IssueAnalysis',
    StackAnalysis: 'StackAnalysis',
    AsmAnalysis: 'AsmAnalysis',
    ChatBot: 'ChatBot',
};
export const AiAnalysisFeedbackType = {
    /** 分析正确 */
    CORRECT: 'CORRECT',
    /** 部分正确 */
    PARTIALLY_CORRECT: 'PARTIALLY_CORRECT',
    /** 分析错误 */
    INCORRECT: 'INCORRECT',
    /** 不清楚 */
    UNCLEAR: 'UNCLEAR',
};
export const AiAnalysisFeedbackTypeToLabel = {
    [AiAnalysisFeedbackType.CORRECT]: ze('分析正确', 'Correct'),
    [AiAnalysisFeedbackType.PARTIALLY_CORRECT]: ze('部分正确', 'Partially Correct'),
    [AiAnalysisFeedbackType.INCORRECT]: ze('分析错误', 'Incorrect'),
    [AiAnalysisFeedbackType.UNCLEAR]: ze('不太清楚', 'Unclear'),
};
